import { useTranslation } from 'react-i18next';
import './index.css';

const getSeriesNo = (_seriesNumber = '0') => {
  const seriesNumber = `0000000000${_seriesNumber}`;
  return seriesNumber.slice(-10);
};

const TitleLine = ({ title = '', seriesNumber = 0, remainTime = '' }) => {
  const seriesNo = getSeriesNo(`${seriesNumber}`);

  const { t } = useTranslation();

  return (
    <>
      <div className="titleLine">
        <span className="title">{title}</span>
        <span className="lotteryNumber">{t('LotteryBlock.board_seriesNo', { seriesNo })}</span>
        <span className=""></span>
        <span className="remainTime">{t('LotteryBlock.board_remainTime', { remainTime })}</span>
      </div>
      <div className="borderLine" />
    </>
  );
};

export default TitleLine;
